import Axios from "axios";
import ApiUtils from "../utils/api_utils";
const BaseUrl = `https://${ApiUtils.authority}`;

const LeaderboardSM = {
  state: {
    leaderboardList: [],
  },
  reducers: {
    setLeaderboardState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getListLeaderboardPoints(payload, rootState) {
      let result;
      await Axios.get(`${BaseUrl}/profiles/api/leaderboard/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          dispatch.LeaderboardSM.setLeaderboardState({
            ...rootState.LeaderboardSM,
            leaderboardList: response.data,
          });
          result = {
            status: 200,
            data: response.data,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListLeaderboardStars(payload, rootState) {
      let result;
      await Axios.get(`${BaseUrl}/profiles/api/stars_leaderboard/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          console.log("call Leaderboard List Stars success: ", response);
          dispatch.LeaderboardSM.setLeaderboardState({
            ...rootState.LeaderboardSM,
            leaderboardList: response.data,
          });
          result = {
            status: 200,
            data: response.data,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
  }),
};

export default LeaderboardSM;
